var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuideFalse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27668",
    "data-name": "Group 27668",
    transform: "translate(0 -0.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_169",
    "data-name": "Ellipse 169",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(0 0.25)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_314",
    "data-name": "Line 314",
    x2: 8,
    transform: "translate(8 12.6)",
    fill: "none",
    stroke: "#979797",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideFalse);
export default __webpack_public_path__ + "static/media/guide-false.a0fea35c75baba87a75eaccc50590027.svg";
export { ForwardRef as ReactComponent };